import React, { useState } from 'react';
import TrailersGrid from './Grid/Trailers';
import ShipmentsGrid from './Grid/Shipments';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  visible: {
    display: 'block'
  },
  hidden: {
    display: 'none'
  }
});
const TrailerStripPriority = ({ hideReportsListItem, classes }) => {
  const [maximizedGrid, setMaximizedGrid] = useState(null);

  const toggleMaximizeGrid = (gridType) => {
    setMaximizedGrid((prev) => {
      const newValue = prev === gridType ? null : gridType;
      hideReportsListItem(newValue === null);
      return newValue;
    });
  };

  return (
    <>
      <div className={maximizedGrid == 'shipments' ? classes.hidden : classes.visible}>
        <TrailersGrid
          toggleMaximize={() => toggleMaximizeGrid('trailers')}
          isMaximized={maximizedGrid == 'trailers'}
        />
      </div>
      <div className={maximizedGrid == 'trailers' ? classes.hidden : classes.visible}>
        <ShipmentsGrid
          toggleMaximize={() => toggleMaximizeGrid('shipments')}
          isMaximized={maximizedGrid == 'shipments'}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(TrailerStripPriority);
